import type { UseFormClearErrors, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { STUDIO_OPTION, buildOtherStudioDetails, buildPersonalStudioDetails } from "../../form-validation/shared";
import type { TeacherOnboardingFormInputs } from "../../form-validation/full-form.schema";

export const useStudioSelection = (
  setValue: UseFormSetValue<TeacherOnboardingFormInputs>,
  watch: UseFormWatch<TeacherOnboardingFormInputs>,
  clearErrors: UseFormClearErrors<TeacherOnboardingFormInputs>,
) => {
  const selectedStudioOption = watch("studio.option");

  const handleStudioTypeChange = (option: STUDIO_OPTION) => {
    if (selectedStudioOption === option) return;
    clearErrors("studio");
    setValue("studio.option", option);

    switch (option) {
      case STUDIO_OPTION.PARTNER:
        setValue("studio", { option, studioId: "", details: null });
        break;
      case STUDIO_OPTION.PERSONAL:
        setValue("studio", { option, studioId: null, details: buildPersonalStudioDetails() });
        break;
      case STUDIO_OPTION.OTHER:
        setValue("studio", { option, studioId: null, details: buildOtherStudioDetails() });
        break;
    }
  };

  return { selectedStudioOption, handleStudioTypeChange };
};
